import { OfferAcceptedListPage } from "@/features/dashboard/pages/OfferAcceptedList";

const OfferAcceptedList = () => {
  return <OfferAcceptedListPage />;
};

export default OfferAcceptedList;
